import * as React from 'react';
import { Breadcrumb, Typography } from 'antd';
import SearchInput from './SearchInput/SearchInput.jsx';
import styles from './index.module.less';

const { Title, Paragraph } = Typography;

export default function ImgContainer({ onChangeKeyword, onChangeFlag,onChangeSelectedIndustry }) {
  return (
    <div className={styles.top_banner}>
      <Breadcrumb
        style={{
          borderBottom: '1px solid #f0f0f0',
        }}
        items={[
          {
            title: 'Home',
          },
          {
            title: 'Support',
          },
          {
            title: 'Resource Center',
          },
        ]}
      />
      <Typography>
        <Title className={styles.title}>Resource Center</Title>
        <Paragraph className={styles.description}>
          Stay informed and up-to-date with the latest documents, firmware, and
          developer tools for your InHand devices.
        </Paragraph>
      </Typography>
      <SearchInput
        onChangeKeyword={onChangeKeyword}
        onChangeFlag={onChangeFlag}
        onChangeSelectedIndustry={onChangeSelectedIndustry}
      />
    </div>
  );
}
